import { render, staticRenderFns } from "./neopark-district.vue?vue&type=template&id=09123b52"
import script from "./neopark-district.vue?vue&type=script&lang=js"
export * from "./neopark-district.vue?vue&type=script&lang=js"
import style0 from "./neopark-district.vue?vue&type=style&index=0&id=09123b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports